export default "__VITE_ASSET__BPwO$3dP__"